module.exports = __webpack_public_path__ + "img/ts13.220348f4.png";